var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{class:{'tabs': true, 'mb-4': _vm.marginBottom, 'border-bottom': _vm.underline, 'border-right': _vm.vertical,},attrs:{"hide-slider":_vm.hideSlider,"slider-size":3,"slider-color":_vm.color,"value":_vm.value,"vertical":_vm.vertical,"centered":_vm.centered},on:{"change":_vm.onChange}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }